import styled from 'styled-components';
import React from 'react';
import RolesSelectionBody from './RolesSelectionBody';
import RolesSelectionHeader from './RolesSelectionHeader';
import { RolesContext, RolesContextType } from './context/RolesContext';

const StyledRolesSelection = styled.div`
  width: 686px;
  height: 513px;
  margin-top: 10px;
  margin-bottom: 7vh;
`;

interface Props extends RolesContextType {}

const RolesSelection = (props: Props) => (
  <RolesContext.Provider value={props}>
    <StyledRolesSelection data-testid="roles-selection">
      <RolesSelectionHeader />
      <RolesSelectionBody />
    </StyledRolesSelection>
  </RolesContext.Provider>
);

export default RolesSelection;
